import { NotAllowedIcon } from "@chakra-ui/icons";
import { Button, GridItem } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

export function EmptyExportListItem({
  scenarioId,
  removeAllowed,
  removeScenario,
  removeDisabled,
}: {
  scenarioId: number;
  removeAllowed: boolean;
  removeScenario: () => void;
  removeDisabled: boolean;
}) {
  return (
    <>
      <GridItem>
        <FormattedMessage
          id="export.scenario_inaccessible"
          defaultMessage="Inaccessible scenario with id {number}"
          values={{ number: scenarioId }}
        />
      </GridItem>
      <GridItem />
      <GridItem>
        <NotAllowedIcon />
      </GridItem>
      <GridItem />
      <GridItem>
        {removeAllowed ? (
          <Button variant="outline" size="sm" onClick={removeScenario} isDisabled={removeDisabled}>
            Remove
          </Button>
        ) : null}
      </GridItem>
    </>
  );
}
